import { render } from "./logo_red.vue?vue&type=template&id=26479137&scoped=true"
import script from "./logo_red.vue?vue&type=script&lang=js"
export * from "./logo_red.vue?vue&type=script&lang=js"

import "./logo_red.vue?vue&type=style&index=0&id=26479137&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26479137"]])

export default __exports__